var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUppershape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 722.256,
    height: 228.873,
    viewBox: "0 0 722.256 228.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.a{fill:url(#a);}.b{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.596,
    y1: 0.961,
    x2: 0.362,
    y2: -0.38,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b93a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dea2b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.134,
    y1: 0.774,
    x2: 0.948,
    y2: -0.026,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-666.536 -69)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M394.651,174.578h0a369.474,369.474,0,0,1-52.7-5.1A435.484,435.484,0,0,1,283.873,155.4a194.717,194.717,0,0,1-35.555-15.57c-11.45-6.267-22.644-13.371-34.495-20.892C165.116,88.029,109.909,52.993,0,50.129c34.3-5.11,67.544-14.366,99.691-23.317,23.722-6.6,48.247-13.433,72.772-18.454,13.2-2.7,25.366-4.684,37.2-6.062A327.974,327.974,0,0,1,247.946,0a292.38,292.38,0,0,1,34.326,2.009,288.609,288.609,0,0,1,35.715,6.562,313.167,313.167,0,0,1,37.371,11.921,368.617,368.617,0,0,1,39.293,18.084v136Z",
    transform: "translate(993.64 122.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M272.431,107.593h-.013a314.407,314.407,0,0,1-33.172-1.748,311.846,311.846,0,0,1-34.576-5.681c-15.36-3.418-30.41-7.375-44.731-11.761C146.321,84.232,133,79.561,120.353,74.52,108.369,69.742,96.68,64.508,85.612,58.965,75.165,53.732,65,48.089,55.412,42.192,45.169,35.895,35.3,29.145,26.092,22.129A320.985,320.985,0,0,1,0,0H720.5V91.87C671.654,65.92,623.677,53.305,573.829,53.305a328.067,328.067,0,0,0-38.284,2.3c-11.829,1.377-24,3.36-37.193,6.062-24.528,5.021-49.049,11.85-72.763,18.454l-1.192.332c-23.824,6.634-48.46,13.494-73.981,18.66-13.53,2.739-26.052,4.751-38.281,6.15A345.889,345.889,0,0,1,272.431,107.593Z",
    transform: "translate(667.791 69.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUppershape);
export default __webpack_public_path__ + "static/media/uppershape.8ed977944b121690bd79a395d8def4d5.svg";
export { ForwardRef as ReactComponent };